/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCenterSupplierUpdateBase
 */
export interface MstCenterSupplierUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplierUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplierUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplierUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    centerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    optimizeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    optimizeRange?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioMon?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioTue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioWed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioThu?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioFri?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioSat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    arrivalRatioSun?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    stopArrival?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    minOrderQuantityOnce?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplierUpdateBase
     */
    orderLeadtime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    orderLimitTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdayMon?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdayTue?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdayWed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdayThu?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdayFri?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdaySat?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableShipdaySun?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MstCenterSupplierUpdateBase
     */
    enableSupplierShipday?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplierUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstCenterSupplierUpdateBase interface.
 */
export function instanceOfMstCenterSupplierUpdateBase(value: object): value is MstCenterSupplierUpdateBase {
    return true;
}

export function MstCenterSupplierUpdateBaseFromJSON(json: any): MstCenterSupplierUpdateBase {
    return MstCenterSupplierUpdateBaseFromJSONTyped(json, false);
}

export function MstCenterSupplierUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterSupplierUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'centerId': json['center_id'] == null ? undefined : json['center_id'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'optimizeType': json['optimize_type'] == null ? undefined : json['optimize_type'],
        'optimizeRange': json['optimize_range'] == null ? undefined : json['optimize_range'],
        'arrivalRatioMon': json['arrival_ratio_mon'] == null ? undefined : json['arrival_ratio_mon'],
        'arrivalRatioTue': json['arrival_ratio_tue'] == null ? undefined : json['arrival_ratio_tue'],
        'arrivalRatioWed': json['arrival_ratio_wed'] == null ? undefined : json['arrival_ratio_wed'],
        'arrivalRatioThu': json['arrival_ratio_thu'] == null ? undefined : json['arrival_ratio_thu'],
        'arrivalRatioFri': json['arrival_ratio_fri'] == null ? undefined : json['arrival_ratio_fri'],
        'arrivalRatioSat': json['arrival_ratio_sat'] == null ? undefined : json['arrival_ratio_sat'],
        'arrivalRatioSun': json['arrival_ratio_sun'] == null ? undefined : json['arrival_ratio_sun'],
        'stopArrival': json['stop_arrival'] == null ? undefined : json['stop_arrival'],
        'minOrderQuantityOnce': json['min_order_quantity_once'] == null ? undefined : json['min_order_quantity_once'],
        'orderLeadtime': json['order_leadtime'] == null ? undefined : json['order_leadtime'],
        'orderLimitTime': json['order_limit_time'] == null ? undefined : json['order_limit_time'],
        'enableShipdayMon': json['enable_shipday_mon'] == null ? undefined : json['enable_shipday_mon'],
        'enableShipdayTue': json['enable_shipday_tue'] == null ? undefined : json['enable_shipday_tue'],
        'enableShipdayWed': json['enable_shipday_wed'] == null ? undefined : json['enable_shipday_wed'],
        'enableShipdayThu': json['enable_shipday_thu'] == null ? undefined : json['enable_shipday_thu'],
        'enableShipdayFri': json['enable_shipday_fri'] == null ? undefined : json['enable_shipday_fri'],
        'enableShipdaySat': json['enable_shipday_sat'] == null ? undefined : json['enable_shipday_sat'],
        'enableShipdaySun': json['enable_shipday_sun'] == null ? undefined : json['enable_shipday_sun'],
        'enableSupplierShipday': json['enable_supplier_shipday'] == null ? undefined : json['enable_supplier_shipday'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstCenterSupplierUpdateBaseToJSON(json: any): MstCenterSupplierUpdateBase {
    return MstCenterSupplierUpdateBaseToJSONTyped(json, false);
}

export function MstCenterSupplierUpdateBaseToJSONTyped(value?: MstCenterSupplierUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'org_supplier_id': value['orgSupplierId'],
        'optimize_type': value['optimizeType'],
        'optimize_range': value['optimizeRange'],
        'arrival_ratio_mon': value['arrivalRatioMon'],
        'arrival_ratio_tue': value['arrivalRatioTue'],
        'arrival_ratio_wed': value['arrivalRatioWed'],
        'arrival_ratio_thu': value['arrivalRatioThu'],
        'arrival_ratio_fri': value['arrivalRatioFri'],
        'arrival_ratio_sat': value['arrivalRatioSat'],
        'arrival_ratio_sun': value['arrivalRatioSun'],
        'stop_arrival': value['stopArrival'],
        'min_order_quantity_once': value['minOrderQuantityOnce'],
        'order_leadtime': value['orderLeadtime'],
        'order_limit_time': value['orderLimitTime'],
        'enable_shipday_mon': value['enableShipdayMon'],
        'enable_shipday_tue': value['enableShipdayTue'],
        'enable_shipday_wed': value['enableShipdayWed'],
        'enable_shipday_thu': value['enableShipdayThu'],
        'enable_shipday_fri': value['enableShipdayFri'],
        'enable_shipday_sat': value['enableShipdaySat'],
        'enable_shipday_sun': value['enableShipdaySun'],
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'remarks': value['remarks'],
    };
}

